/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUpdateSupplier
 */
export interface MelcoModelsUpdateSupplier {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpdateSupplier
     */
    name?: string | null;
}

export function MelcoModelsUpdateSupplierFromJSON(json: any): MelcoModelsUpdateSupplier {
    return MelcoModelsUpdateSupplierFromJSONTyped(json, false);
}

export function MelcoModelsUpdateSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUpdateSupplier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MelcoModelsUpdateSupplierToJSON(value?: MelcoModelsUpdateSupplier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


